//@flow
import * as Immutable from 'immutable';

import { MapControls } from 'common/models/flow/MapControls';
import type { MapControlsModelType } from 'common/models/flow/MapControls';
import { MarkerTypeEnum } from 'common/enums/MapEnum';

class InternalMapControls extends MapControls {
    static fromJS(json: MapControlsModelType): InternalMapControls {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    static getDefaultModeControls(): InternalMapControls {
        return InternalMapControls.fromJS({
            showMarkers: true,
            markerType: MarkerTypeEnum.Numbered,
            drivingRoute: true,
            aerialRoute: false,
            clusters: false,
            polygon: false,
            showZones: false,
            selectedZoneFilter: 'ALL',
            showUnassignedMarkers: false,
            showPolygonClustersFor: 'ALL_TOURS'
        });
    }
}

export { InternalMapControls as MapControls };
